import styled from "styled-components";

export const MockupProdutoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .mockup-card {
    width: 340px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    padding: 24px;
    border: 1px solid ${(props) => props.theme.colors.placeholder};
    border-radius: 16px;
    background: ${(props) => props.theme.colors.white};
  }

  /* === Image section === */
  .mockup-foto-area {
    width: 290px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
  }

  .mockup-foto-wrapper {
    position: relative;
    width: 290px;
    height: 290px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 14px;
    }

    .no-image {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: ${(props) => props.theme.colors.elements};
      border-radius: 14px;
      color: ${(props) => props.theme.colors.placeholder};
      font-size: 1.4rem;
    }
  }

  .carousel-btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    color: ${(props) => props.theme.colors.tertiary};
    font-size: 2.4rem;
    z-index: 2;
    padding: 0;

    &.prev { left: 6px; }
    &.next { right: -14px; }
  }

  .badges {
    position: absolute;
    top: 8px;
    right: 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    z-index: 2;

    .badge {
      background: ${(props) => props.theme.colors.primary};
      color: #fff;
      font-weight: 500;
      padding: 2px 10px;
      border-radius: 14px;
      text-align: center;
      overflow: hidden;
    }
  }

  /* === Below photo row: counter + dots | share === */
  .mockup-below-foto {
    width: 290px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .foto-counter {
    display: flex;
    align-items: center;
    gap: 6px;

    .counter-text {
      color: ${(props) => props.theme.colors.tertiary};
    }

    .dots {
      display: flex;
      gap: 3px;

      .dot {
        height: 10px;
        border-radius: 6px;
        background: ${(props) => props.theme.colors.placeholder};
        transition: all 0.2s;

        &.active {
          width: 20px;
          background: ${(props) => props.theme.colors.tertiary};
        }
        &:not(.active) {
          width: 10px;
        }
      }
    }
  }

  .mockup-share {
    display: flex;
    align-items: center;
    gap: 6px;
    justify-content: flex-end;

    svg {
      width: 15px;
      height: 15px;

      path {
        fill: ${(props) => props.theme.colors.tertiary};
      }
    }

    span {
      color: ${(props) => props.theme.colors.tertiary};
    }
  }

  /* === Description section === */
  .mockup-descricao-section {
    width: 290px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }

  .mockup-nome-descricao {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .mockup-titulo-sku {
    display: flex;
    flex-direction: column;
    gap: 3px;
    width: 100%;
  }

  .mockup-nome {
    font-weight: 700;
    color: ${(props) => props.theme.colors.tertiary};
    line-height: 1.3;
    word-break: break-word;
    overflow: hidden;
    text-align: justify;
  }

  .mockup-sku {
    color: ${(props) => props.theme.colors.tertiary};
    text-align: justify;
  }

  .mockup-descricao {
    color: ${(props) => props.theme.colors.tertiary};
    text-align: justify;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 52px;
    word-break: break-word;
    line-height: 1.35;
  }

  /* === Separator === */
  .mockup-separator {
    width: 120px;
    height: 0;
    margin: 0;
    border: none;
    border-top: 1px solid ${(props) => props.theme.colors.placeholder};
  }

  /* === Variation pills (<=2 values) === */
  .mockup-pills {
    width: 100%;
    display: flex;
    gap: 8px;

    .pill {
      flex: 1 0 0;
      min-width: 0;
      padding: 10px 16px;
      border-radius: 100px;
      font-weight: 700;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s;
      overflow: hidden;
      white-space: nowrap;
      line-height: 1;

      border: 1px solid ${(props) => props.theme.colors.placeholder};
      background: transparent;
      color: ${(props) => props.theme.colors.primary};

      &.active {
        background: ${(props) => props.theme.colors.primary};
        border-color: ${(props) => props.theme.colors.primary};
        color: #f8f9fa;
      }
    }
  }

  /* === Variation pills slider === */
  .mockup-pills-slider {
    width: 100%;
  }

  .mockup-pills-track {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding-right: 20px;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    .pill {
      flex-shrink: 0;
      min-width: calc(50% - 4px);
      padding: 10px 16px;
      border-radius: 100px;
      font-weight: 700;
      text-align: center;
      cursor: pointer;
      transition: all 0.2s;
      white-space: nowrap;
      line-height: 1;

      border: 1px solid ${(props) => props.theme.colors.placeholder};
      background: transparent;
      color: ${(props) => props.theme.colors.tertiary};

      &.active {
        background: ${(props) => props.theme.colors.primary};
        border-color: ${(props) => props.theme.colors.primary};
        color: #fff;
      }
    }
  }

  /* === Variation detail block === */
  .mockup-variacao-bloco {
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 10px;

    .variacao-left {
      display: flex;
      flex-direction: column;
      gap: 3px;
      flex: 1;
      min-width: 0;
    }

    .variacao-nome {
      font-weight: 700;
      color: ${(props) => props.theme.colors.tertiary};
      line-height: 1.3;
      text-align: justify;
    }

    .variacao-detalhes {
      display: flex;
      gap: 4px;
      color: ${(props) => props.theme.colors.tertiary};
      font-weight: 400;
    }

    .mockup-precos {
      display: flex;
      flex-direction: column;
      margin-top: 2px;

      .preco-de {
        color: ${(props) => props.theme.colors.tertiary};
        text-decoration: line-through;
        line-height: normal;
      }

      .preco-por {
        font-weight: 700;
        color: ${(props) => props.theme.colors.tertiary};
        line-height: 1.3;
        text-align: justify;
      }
    }
  }

  /* === Stacked variations list (single level, no secondary) === */
  .mockup-variacoes-lista {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .mockup-mais-variacoes {
      text-align: center;
      color: ${(props) => props.theme.colors.tertiary};
    }
  }

  .btn-add {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${(props) => props.theme.colors.primary};
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: default;
    flex-shrink: 0;

    svg {
      width: 14px;
      height: 14px;
      fill: #fff;
    }
  }
`;
